// extracted by mini-css-extract-plugin
module.exports = {"wrap":"JS","heading":"KS","formError":"LS"};